import { BizValueAddedService } from 'src/components/biz-value-added-service';

export default BizValueAddedService;
